import moment from 'moment'

type RangeText = 'day' | 'month'
type CsvReportParams = {
  fileName: string
  range: RangeText
}

export class CsvReport {
  fileName: string
  range: RangeText

  constructor(params: CsvReportParams) {
    this.fileName = params.fileName
    this.range = params.range
  }

  get title() {
    return this.fileName.split('/')[2].split(']')[0]
  }

  url(date: Date) {
    return moment(date).format(this.fileName)
  }
}

export type CsvReports = CsvReport[]
